import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
class ServiceTabExample extends Component {

    render() {

        /* service tab menu */
        let serviceTabMenuData = [
            { iconName: 'flaticon-002-welding', tabMenuName: 'Construction' },
            { iconName: 'flaticon-004-walkie-talkie', tabMenuName: 'Electrical' },
            { iconName: 'flaticon-015-cart', tabMenuName: 'Road Works' },
            { iconName: 'flaticon-010-tank-1', tabMenuName: 'Sale and Rental' }
        ];

        let serviceTabMenuDatalist = serviceTabMenuData.map((val, i) => {
            return (
                <Tab key={i}>  <span className="icon"><i className={val.iconName} /></span> <span className="text">{val.tabMenuName}</span></Tab>
            )
        });


        /* service tab content */

        let serviceTabContentData = [
            { bgUrl: "construction.jpg", contentTitle: 'Construction', contentDesc: 'From groundbreaking to completion, we deliver exceptional construction projects with precision engineering and unwavering commitment to quality. Our experienced team transforms architectural visions into structural reality.', serviceLink: 'service-details-left-sidebar' },
            { bgUrl: "electric.jpg", contentTitle: 'Electrical', contentDesc: 'Powering progress with cutting-edge electrical solutions for industrial and commercial projects. Our certified engineers ensure safe, efficient, and code-compliant installations that meet the highest industry standards.', serviceLink: 'service-details-left-sidebar' },
            { bgUrl: "road-construc.jpg", contentTitle: 'Road Works', contentDesc: 'Building the infrastructure that connects communities. We specialize in highway construction, road rehabilitation, and pavement solutions that stand the test of time and heavy traffic demands.', serviceLink: 'service-details-left-sidebar' },
            { bgUrl: "s4.jpg", contentTitle: 'Sale and Rental', contentDesc: 'Access top-tier construction equipment when you need it. Our comprehensive fleet of modern machinery is available for purchase or rental, backed by expert maintenance and 24/7 technical support.', serviceLink: 'service-details-left-sidebar' }
        ];

        let serviceTabContentDatalist = serviceTabContentData.map((val, i) => {
            return (
                <TabPanel key={i}>
                    <div className="service-tab__single-content-wrapper" style={{ backgroundImage: `url(assets/img/others/${val.bgUrl})` }}>
                        <div className="service-tab__single-content">
                            <h3 className="service-tab__title">{val.contentTitle}</h3>
                            <p className="service-tab__text">{val.contentDesc}</p>
                            <a href={`${process.env.PUBLIC_URL}/${val.serviceLink}`} className="see-more-link">SEE MORE</a>
                        </div>
                    </div>
                </TabPanel>
            )
        });

        return (
            <div>

                {/*====================  service tab area ====================*/}
                <div className="service-tab-area section-space--inner--120" data-aos="fade-up">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title-area text-center">
                                    <h2 className="section-title section-space--bottom--50">Our Services</h2>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                {/* service tab wrapper */}

                                <div className="service-tab-wrapper">
                                    <Tabs>
                                        <div className="row no-gutters">
                                            <div className="col-md-4">
                                                <TabList>
                                                    <div className="service-tab__link-wrapper">
                                                        {serviceTabMenuDatalist}
                                                    </div>
                                                </TabList>
                                            </div>

                                            <div className="col-md-8">
                                                {serviceTabContentDatalist}
                                            </div>
                                        </div>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*====================  End of service tab area  ====================*/}
            </div>
        )
    }
}

export default ServiceTabExample;